module.exports = __webpack_public_path__ + "img/user.7aafc6e2.svg";